let app

export default {
  'entityName': 'log',
  pagination: {
    'itemsPerPage': 5,
    'page': 1,
    'sortBy': 'insert_at',
    'descending': true
  },
  setApp(appp) {
    app = appp
  },
  filterStorage: {},
  'fields': [
    {
      value: 'insert_at',
      text: 'Insert at',
      'type': 'date',
      'table': {
        'sortable': true,
        'filter': true
      },
      tooltip: () => {
        return "Click to copy the REQUEST and RESPONSE json into the clipboard"
      },
      click: (item) => {
        app.copyLog(item)
      }
    },
    {
      value: 'account.surname',
      text: 'Account',
      'type': 'autocomplete',
      'table': {
        'sortable': false,
        'filter': true
      },
      filter: (item, search) => [{ 'account.name': `%${search}%`}, {'account.surname' : `%${search}%`}],
      render: item => `${item.account.name} ${item.account.surname} (${item.account.role})`,
    },
    {
      value: 'route',
      text: 'Route',
      'type': 'text',
      'table': {
        'sortable': false,
        'filter': true
      },
    },
    {
      value: 'http_verb',
      text: 'HTTP Method',
      type: 'list',
      list: ['POST', 'PUT', 'DELETE'],
      'table': {
        'sortable': false,
        'filter': true
      },
      filter: (item, search) => { return { 'http_verb': `${search}` } },
    },
  ],
  actions: []
}
